import { Box, Typography, useTheme } from "@mui/material";

const MetricCard = ({ title, value, color }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: 1,
        p: 2,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h4" color={color} fontWeight={600} sx={{
        fontSize: '1.4rem'
      }}>
        {value}
      </Typography>
    </Box>
  );
};

export default MetricCard;
